// Thin compatibility wrapper: RichContent is the html-kind case of the
// universal ContentView (app/richEdit/content/). Same DOM as always.
import { ContentView } from './content'

export function RichContent({ html, className }: { html: string; className?: string }) {
  return <ContentView doc={{ kind: 'html', value: html }} className={className} />
}
